export default function Card({children, ctype, className, ...rest}) {
    const classes = `card ${ctype} ${className}`;
    return(<div className={classes} {...rest} >{children}</div>);
}

Card.Header = function CardHeader({children, ctype, className, ...rest}) {
    const classes = `card-header ${ctype} ${className}`;
    return(<div className={classes} {...rest} >{children}</div>);
}

Card.Body = function CardBody({children, ctype, className, ...rest}) {
    const classes = `card-body ${ctype} ${className}`;
    return(<div className={classes} {...rest} >{children}</div>);
}

